/**
 * Message types for iframe communication
 */
export const MESSAGE_TYPES = {
  REQUEST_CREDENTIALS: "REQUEST_CREDENTIALS",
  PROVIDE_CREDENTIALS: "PROVIDE_CREDENTIALS",
} as const;

/**
 * Type union of all message types
 */
export type MessageType = (typeof MESSAGE_TYPES)[keyof typeof MESSAGE_TYPES];

/**
 * Credentials interface for authentication
 */
export interface Credentials {
  token: string;
  project: string;
  baseUrl: string;
}

/**
 * Message sent from iframe when it's ready to receive credentials
 */
export interface AppReadyMessage {
  type: typeof MESSAGE_TYPES.REQUEST_CREDENTIALS;
}

/**
 * Message sent to iframe containing credentials
 */
export interface ProvideCredentialsMessage {
  type: typeof MESSAGE_TYPES.PROVIDE_CREDENTIALS;
  credentials: Credentials;
}

/**
 * Union type for all incoming messages from iframe
 */
export type IncomingMessage = AppReadyMessage;

/**
 * Union type for all outgoing messages to iframe
 */
export type OutgoingMessage = ProvideCredentialsMessage;
